import { useMemo, useEffect } from 'preact/hooks';
import { useCachedFetch } from '@core/utils/hooks/use-cached-fetch';
import { useAdminContext } from '../../../context/admin.context';

export function useSystemData(requestParams) {
    const endpoint = '/systems';

    const { addCacheKey } = useAdminContext();

    const { data, isLoading, error } = useCachedFetch(endpoint, requestParams, {
        enabled: true,
        keepPreviousData: true,
    });

    useEffect(() => {
        addCacheKey('systemTable', [endpoint, requestParams]);
    }, [endpoint, requestParams]);

    const tableData = useMemo(() => {
        const items = data?.items || [];
        const total = data?.total || 0;
        return { rows: items, total, isLoading };
    }, [data, isLoading]);

    return { data, error, isLoading, tableData };
}
